// Admin-host session open / logout (wiki/feature-admin-portal.md).
//
// POST /api/admin/session mints the `vd_admin` cookie for the Cloudflare Access
// identity on the request (no body); only the dev login (admin.localhost, no
// Access app) takes `{ email }`. Every refusal is a bare 404.

import { api, ApiError } from './client';

/** Open (or renew) the admin session. Resolves `false` on a refusal; throws on anything else. */
export async function openAdminSession(devEmail?: string): Promise<boolean> {
  try {
    await api.post('/admin/session', devEmail ? { email: devEmail } : undefined, { toast: false });
    return true;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return false;
    throw e;
  }
}

/** Clear the admin session cookie. Best-effort — never throws. */
export async function adminLogout(): Promise<void> {
  try {
    await api.post('/admin/logout', undefined, { toast: false });
  } catch {
    // Best-effort — the caller drops to anonymous regardless.
  }
}
